// reducers/masterReducer.js

export const initialMasterState = {
    parks: [],
    parksWithSlug: [],
    months: [],
    packageFeature: [],
    packageInclude: [],
    animals: [],
    animalsDefault: [],
    locations: [],
    vehicles: [],
    bonusExperience: [],
    suggestionCategory: [],

    safariType: [],
    safariAgenda: [],
    safariCategory: [],
    safariHostType: [],
    safariSortBy: [],
    safariPackSortBy: [],
    parksSortBy: [],
    flagReasons: [],
    masterLoading: true
};

export const masterReducer = (state = initialMasterState, action) => {
    switch (action.type) {
        case "SET_MASTER_LOADING":
            return {
                ...state,
                masterLoading: typeof action.payload === "boolean" ? action.payload : state.masterLoading,
            };
        case 'SET_MASTER_PARKS':
            return {
                ...state,
                parks: Array.isArray(action.payload) ? action.payload : state.parks,
            };
        case 'SET_MASTER_PARKS_WITH_SLUG':
            return {
                ...state,
                parksWithSlug: Array.isArray(action.payload) ? action.payload : state.parksWithSlug,
            };
        case 'SET_MASTER_MONTHS':
            return {
                ...state,
                months: Array.isArray(action.payload) ? action.payload : state.months,
            };
        case 'SET_MASTER_PACKAGE_FEATURE':
            return {
                ...state,
                packageFeature: Array.isArray(action.payload) ? action.payload : state.packageFeature,
            };
        case 'SET_MASTER_PACKAGE_INCLUDE':
            return {
                ...state,
                packageInclude: Array.isArray(action.payload) ? action.payload : state.packageInclude,
            };
        case 'SET_MASTER_ANIMALS':
            return {
                ...state,
                animals: Array.isArray(action.payload) ? action.payload : state.animals,
            };
        case 'SET_MASTER_ANIMALS_DEFAULT':
            return {
                ...state,
                animalsDefault: Array.isArray(action.payload) ? action.payload : state.animalsDefault,
            };
        case 'SET_MASTER_LOCATIONS':
            return {
                ...state,
                locations: Array.isArray(action.payload) ? action.payload : state.locations,
            };
        case 'SET_MASTER_VEHICLES':
            return {
                ...state,
                vehicles: Array.isArray(action.payload) ? action.payload : state.vehicles,
            };
        case 'SET_MASTER_BONUS_EXPERIENCE':
            return {
                ...state,
                bonusExperience: Array.isArray(action.payload) ? action.payload : state.bonusExperience,
            };
        case 'SET_MASTER_SUGGESTION_CATEGORY':
            return {
                ...state,
                suggestionCategory: Array.isArray(action.payload) ? action.payload : state.suggestionCategory,
            };

        //
        case 'SET_MASTER_SAFARI_TYPE':
            return {
                ...state,
                safariType: Array.isArray(action.payload) ? action.payload : state.safariType,
            };
        case 'SET_MASTER_SAFARI_THEME':
            return {
                ...state,
                safariAgenda: Array.isArray(action.payload) ? action.payload : state.safariAgenda,
            };
        case 'SET_MASTER_SAFARI_CATEGORY':
            return {
                ...state,
                safariCategory: Array.isArray(action.payload) ? action.payload : state.safariCategory,
            };
        case 'SET_MASTER_SAFARI_HOST_TYPE':
            return {
                ...state,
                safariHostType: Array.isArray(action.payload) ? action.payload : state.safariHostType,
            };
        case 'SET_MASTER_SAFARI_SORT_BY':
            return {
                ...state,
                safariSortBy: Array.isArray(action.payload) ? action.payload : state.safariSortBy,
            };
        case 'SET_MASTER_SAFARI_PACKAGES_SORT_BY':
            return {
                ...state,
                safariPackSortBy: Array.isArray(action.payload) ? action.payload : state.safariPackSortBy,
            };

        case 'SET_MASTER_PARKS_SORT_BY':
            return {
                ...state,
                parksSortBy: Array.isArray(action.payload) ? action.payload : state.parksSortBy,
            };
        case "SET_MASTER_FLAG_REASONS":
            return {
                ...state,
                flagReasons: Array.isArray(action.payload) ? action.payload : state.flagReasons,
            };

        default:
            return state;
    }
};
